import { Box, Text, Button } from "@chakra-ui/react";

const StudentItem = ({
  index,
  setToggleForm,
  setClickedStudentIndex,
  setUpdatingStudentId,
  studentId,
  name,
}: {
  index: number;
  setToggleForm: (type: "add" | "update", triggered: boolean) => void;
  setClickedStudentIndex: React.Dispatch<React.SetStateAction<number>>;
  setUpdatingStudentId: React.Dispatch<React.SetStateAction<number>>;
  studentId: number | undefined;
  name: string | undefined;
}) => {
  return (
    <Box
      display={"flex"}
      my="2rem"
      justifyContent="space-between"
      alignItems={"center"}
      border="1px solid"
      borderColor={"blue.500"}
      rounded="md"
      px="1rem"
      py="1rem"
    >
      <Text>{name ? name : `Student ${index + 1}`}</Text>
      <Button
        size={"sm"}
        onClick={() => {
          setToggleForm(studentId ? "update" : "add", true);
          setClickedStudentIndex(index);
          setUpdatingStudentId(studentId ? studentId : 0);
        }}
      >
        {studentId ? "Update" : "Add"} details
      </Button>
    </Box>
  );
};

export default StudentItem;
